var React = require('react');

function ExclamationPurple (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","fill":"#d16aa9","r":"10","key":0}),React.createElement("path",{"d":"m11.128 8.01v-3.01h-1.82v3.01l.28 3.57h1.26zm-2.128 5.712c0 .686.532 1.218 1.218 1.218s1.232-.532 1.232-1.218-.546-1.232-1.232-1.232-1.218.546-1.218 1.232z","fill":"#fffbe7","key":1})]);
}

ExclamationPurple.defaultProps = {"fill":"none","height":"20","viewBox":"0 0 20 20","width":"20"};

module.exports = ExclamationPurple;

ExclamationPurple.default = ExclamationPurple;
